// extracted by mini-css-extract-plugin
module.exports = {"zendesk_button":"CustomizedZendesk_zendesk_button__30Chz","zendesk_button_icon":"CustomizedZendesk_zendesk_button_icon__1kN1H"};